import React from 'react';
import '../../styles/table-main/main.css';

const Main = () => {
    return (
        <div id='tableMain'>
            <div className="table-main">
                <div className="container mt-5 admin-container">
                    <div>
                        <h2 className="my-heading">List of Colleges</h2>
                        <p style={{ fontSize: "large", fontWeight: 500, lineHeight: "25px" }}>
                            Govt. &amp; Aided, Self Financing, Professional Courses Inst./Colleges
                            (District wise)
                        </p>
                    </div>
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                {/* <th>Designation</th> */}
                                <th>College Types</th>
                                <th>View</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                {/* <td>Chancellor</td> */}
                                <td>
                                    All College List of Meerut Mandal (Govt. &amp; Aided Colleges /
                                    Colleges having Professional Courses)
                                </td>
                                <td>
                                    <button className="btn btn-primary btn-download">
                                        <a
                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/colleges/govt-aided-colleges-170823.pdf"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            View
                                        </a>
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                {/* <td>Vice-Chancellor</td> */}
                                <td>
                                    Self Financing Colleges (Institutes/Colleges having Professional
                                    Courses)
                                </td>
                                <td>
                                    <button className="btn btn-primary btn-download">
                                        <a
                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/colleges/List-of-Professional-Institute-020817.pdf"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            View
                                        </a>
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                {/* <td>Vice-Chancellor</td> */}
                                <td>SFS Traditional Courses</td>
                                <td>
                                    <button className="btn btn-primary btn-download">
                                        <a
                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/colleges/List-Self-Finance-2018.pdf"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            View
                                        </a>
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                {/* <td>Vice-Chancellor</td> */}
                                <td>Combined List of Self Finance Colleges/ Institutes</td>
                                <td>
                                    <button className="btn btn-primary btn-download">
                                        <a
                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/colleges/combine-list-Self-Finacnce-All-course.pdf"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            View
                                        </a>
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                {/* <td>Vice-Chancellor</td> */}
                                <td>Institute/ Colleges (B.Ed. Courses)</td>
                                <td>
                                    <button className="btn btn-primary btn-download">
                                        <a
                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/colleges/Institute-Bed.pdf"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            View
                                        </a>
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                {/* <td>Vice-Chancellor</td> */}
                                <td>L.L.B. Colleges List</td>
                                <td>
                                    <button className="btn btn-primary btn-download">
                                        <a
                                            href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/colleges/LLB-college-list-23.pdf"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            View
                                        </a>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    )
}

export default Main;